import { useState } from "react";

import useMessages from "../../data/useMessages";
import { ILead } from "../../models/Lead";
import { QualifyLead } from "../../services/TemplateService";
import useNotification from "../notifications/useNotifications";
import { ButtonInput } from "../shared/Inputs/ButtonInput";


export default function SendQualifierButton({ lead }: { lead: ILead }) {
  const { sendText } = useMessages();
  const { addNotification } = useNotification();
  const [confirmOpen, setConfirmOpen] = useState(false);

  const handleQualifyText = () => {

    const body = {
      leadId: lead.id,
      templateId: QualifyLead.Message,
      contactId: lead.contact?.id,
      recipient: lead.contact?.telephone1,
      substitutions: {
        "{{name}}": lead.contact?.fullname!,
        "{{make}}": lead.vehicle?.combinedMake!,
        "{{model}}": lead.vehicle?.combinedModel!,
        "{{telephone}}": lead.contact?.telephone1!,
        "{{price}}": lead.priceWithVAT.toString()!,
      },
    };

    sendText.mutate(body, {
      onSuccess: () => {
        setConfirmOpen(false);
        addNotification({
          variant: "success",
          primaryText: "Text sent successfully",
        });
      },
      onError: () => {
        addNotification({
          variant: "error",
          primaryText: "Error sending text",
        });
      },
    });
  }


  return (
    <ButtonInput label={"Send Qualifier Text"} isSubmit={false} onClick={handleQualifyText} classes="" />
  );
}